const ApplicantNotFound = () => (
    <div className="flex h-full w-full max-w-4xl flex-col items-center justify-center gap-4 text-center">
        <div className="font-bold text-3xl">Ungültiger Link</div>
        <div className="text-default-500">
            Bitte überprüfen Sie den Link oder wenden Sie sich an den Absender.
        </div>
    </div>
)

export { ApplicantNotFound };